import { render } from "./productPage.vue?vue&type=template&id=f83c8acc&scoped=true"
import script from "./productPage.vue?vue&type=script&lang=js"
export * from "./productPage.vue?vue&type=script&lang=js"

import "./productPage.vue?vue&type=style&index=0&id=f83c8acc&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f83c8acc"]])

export default __exports__